import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SidebarStore {
    private isOpenSignal = signal<boolean>(false);
    private tabVisibleSignal = signal<boolean>(false);

    readonly isOpen = this.isOpenSignal.asReadonly();
    readonly tabVisible = this.tabVisibleSignal.asReadonly();

    close() {
        if (this.isOpen()) this.toggle();
        if (this.tabVisible()) this.hideTab();
    }

    toggle() {
        this.isOpenSignal.update((value) => !value);
        if (this.tabVisible() === false) this.tabVisibleSignal.update(() => true);
    }

    hideTab() {
        this.tabVisibleSignal.update(() => false);
    }
}
